import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import theme from './theme/theme'

import HomePage from './pages/HomePage'

import AuthPage from './components/AuthPage'
import LogIn from './pages/authentication/Login'
import OfferManagement from './pages/finance/offer/ManageOffer'
import BasketManagement from './pages/finance/basket/ManageBasket'
import ViewBasketDetails from './pages/finance/basket/ViewBasketDetails'
import FinancingRequestManagement from './pages/finance/financingRequest/ManageFinancingRequest'
function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/login" element={<LogIn />} />
            <Route element={<AuthPage />}>
              <Route path="/" element={<HomePage />} />
             <Route path="/manageOffer" element={<OfferManagement />} />
             <Route path="/manageBasket" element={<BasketManagement />} />
             <Route path="/viewBasket/:basketId/:supplierName/hasOffer/:hasOffer" element={<ViewBasketDetails />} />
             <Route path="/manageFinancingRequest" element={<FinancingRequestManagement />} />
            
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  )
}

export default App
